// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PunkImageVoteTable_wrapper__3qpvO"};